/**
 * patrol-new-edit.js
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import Select from 'components/form-inputs/select';
import PatrolNonSearchEdit from '../patrol-non-search/patrol-non-search-edit';
import PatrolBuildingSearchEdit from '../patrol-building-search/patrol-building-search-edit';
import PatrolEvidenceSearchEdit from '../patrol-evidence-search/patrol-evidence-search-edit';
import PatrolHumanSearchEdit from '../patrol-human-search/patrol-human-search-edit';
import PatrolTrackingEdit from '../patrol-tracking/patrol-tracking-edit';


export default function PatrolNewEdit(props) {
  const {
    drawerState,
    edit,
  } = props;
  const { t } = useTranslation(edit.translation);
  const { t: gt } = useTranslation('general');
  const [patrolType, setPatrolType] = React.useState();

  // exclude obediencce, agility, other and scenario from deployment patrol type options
  const typeOptions = React.useMemo(() => Types.Patrol.Deployment.entries(gt), [gt]);


  return (
    <>
      <EditorIconSection
        iconName='patrol-other'
        iconMarginTop={8}
        helpProps={{
          translation: edit.translation,
          section: 'patrol'
        }}
      >

        {/* patrol type selector */}
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('patrol.patrolType.helpTitle')}
          text={t('patrol.patrolType.helpInfo')}
        >
          <Select
            name='newPatrolTypeUnused'
            label={t('patrol.patrolType.label')}
            options={typeOptions}
            defaultValue=''
            style={{ maxWidth: 175 }}
            onChange={e => setPatrolType(e.target.value)}
            rules={{
              required: t('patrol.patrolType.errMsgEmpty')
            }}
          />
        </HelpTextItem>

      </EditorIconSection>


      {/* non-search */}
      {patrolType === Types.Patrol.NONSEARCH &&
      <PatrolNonSearchEdit {...props} />}

      {/* building search */}
      {patrolType === Types.Patrol.BUILDING_SEARCH &&
      <PatrolBuildingSearchEdit {...props} />}

      {/* evidence search */}
      {patrolType === Types.Patrol.EVIDENCE_SEARCH &&
      <PatrolEvidenceSearchEdit {...props} />}

      {/* human search */}
      {patrolType === Types.Patrol.HUMAN_SEARCH &&
      <PatrolHumanSearchEdit {...props} />}

      {/* tracking */}
      {patrolType === Types.Patrol.TRACKING &&
      <PatrolTrackingEdit {...props} />}
    </>
  );
}